export const fetchDavtTasksURL = (page, search = '', taskName) => {
  if (taskName === 'escalated') {
    return `/customer/davt-task/?page=${page}&escalated=true${search}`;
  } else {
    return `/customer/davt-task/?page=${page}${search}`;
  }
};

export const fetchTaskDetailsURL = (taskId) => {
  return `/customer/davt-task/${taskId}/`;
};

export const sendTaskForApprovalURL = (actionType) => {
  return `/customer/davt-task/${actionType}/`;
};

export const submitFSQuestionnaireURL = () => {
  return `/customer/davt-task/questions/`;
};

export const toggleDavtUserStatusURL = () => {
  return `/customer/toggle-davt-employee-status/`;
};
